import { RuleId, RuleLevel } from '../../../types-v2';
import { getAlternativeTextCardReason } from '../../../utils/get-alt-text-failure-reason';
export const staticAltTextRule = {
  checker: _ref => {
    let {
      images
    } = _ref;
    const failedElements = [];
    images.forEach(_ref2 => {
      let {
        id,
        alt,
        decorative
      } = _ref2;
      const isDecorative = !!decorative && !alt; // if image is marked as decorative but user added alt text in editor, we render alt status
      const failedReason = isDecorative ? undefined : getAlternativeTextCardReason(alt);
      if (failedReason) {
        failedElements.push({
          failedReason,
          id
        });
      }
    });
    const status = failedElements.length === 0 ? 'passed' : 'failed';
    return {
      failedElements,
      status: images.length > 0 ? status : 'not-applicable'
    };
  },
  level: RuleLevel.Page,
  ruleId: RuleId.STATIC_ALT_TEXT
};
//# sourceMappingURL=static-alt-text.js.map